import { render, staticRenderFns } from "./LabItem.vue?vue&type=template&id=1759c178&scoped=true"
import script from "./LabItem.vue?vue&type=script&lang=js"
export * from "./LabItem.vue?vue&type=script&lang=js"
import style0 from "./LabItem.vue?vue&type=style&index=0&id=1759c178&prod&scoped=true&lang=css"
import style1 from "./LabItem.vue?vue&type=style&index=1&id=1759c178&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1759c178",
  null
  
)

export default component.exports